import useAxiosPrivate from "./useAxiosPrivate";
import { useLocation, useNavigate } from "react-router";
import { useAuth } from "../context/useAuth";
import { useOrgApp } from "../context/useOrgApp";



const useGraphQLQuery = () => {
    const axiosPrivate = useAxiosPrivate();
    const location = useLocation();
    const navigate = useNavigate();
    const { logout } = useAuth();
    const { orgApp } = useOrgApp();
    const domainIdUrl:string = orgApp.domainId ? `/${orgApp.domainId}` : '';

    return async (query: string) => {
        try {
            return await axiosPrivate.post(domainIdUrl, { query });
        } catch (err: any) {
            if (err.response?.status === 401) {   
                console.info("session expired")
                logout(); 
                navigate('/login', { state: { from: location }, replace: true });
            } else {
                console.error("error fetching data: ", err)
            }
        }
    }
}

export default useGraphQLQuery;